import {ObjectUtil} from '../util/object-util';
import {Company} from './proposal/company';
import {SummaryPolicy} from '../enum/notifications/summary-policy';

export class User {
  //personal information
  id: string = null;
  companyId: string = null;
  firstName: string = null;
  lastName: string = null;
  type: string = null;

  //contact information
  telephoneNumber: string = null;
  mobileNumber: string = null;
  email: string = null;
  street: string = null;
  houseNumber: string = null;
  postalCode: string = null;
  location: string = null;
  countryCode: string = null;
  company: Company;
  privacyPolicyAccepted: boolean;
  emailNotifications: boolean = null;
  showAnnouncementDialog: boolean = null;
  showSmallDeviceDialog: boolean = null;
  isCorporateAdmin: boolean = null;
  isRepresentative: boolean = null;
  isBoardMember: boolean = null;
  isEarlyBird: boolean = null;
  isBusinessAdmin: boolean = null;
  language: string = null;
  notificationSummaryPolicy: SummaryPolicy = null;
  skenDataAccountId: string = null;
  userRepresentativeId: string = null;
  representedUsers: string[] = [];

  constructor(object?: any) {
    if (object == null) {
      return;
    }
    ObjectUtil.assign(this, object);
  }

  update(object: Partial<User>) {
    ObjectUtil.assign(this, object);
  }

}
